import React from "react";
import i18n from "i18next";
import {
  CreditingDataInterface
} from "../interfaces/CreditingDataInterface";

import { useAuth } from "./Auth";

const CreditingContext = React.createContext({
  loading: true,
  creditTransaction: (creditingData) => {}
});

export const CreditingProvider = (props) => {
  const auth = useAuth();

  const [loading, setLoading] = React.useState(true);

  const creditTransaction = async (creditingData: CreditingDataInterface) => {
    if (!creditingData) {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const body = {
        memberid: creditingData.memberId,
        lastname: creditingData.lastName,
        activityDate: creditingData.activityDate,
        storeNumber: creditingData.storeNumber,
        referenceNumber: creditingData.referenceNumber,
        productTypeCode: creditingData.productTypeCode,
        partnerReference: creditingData.partnerReference,
        marketingCode: creditingData.marketingCode,
        creditedMiles: creditingData.creditedMiles,
      };

      const requestOptions = {
        method: "POST",
        responseType: "application/json",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": "Bearer " + auth.currentToken()
        }
      };

      const rawData = await fetch(process.env.REACT_APP_PACTOOL_API_URL + "/crediting",requestOptions)
        .then((response) => response.json())
        .then((response) => {
          return response;
        });

      // 1000 - login sucessful with token
      if (rawData?.code === 1000) {
        return {
          status: "SUCCESS",
          firstName: rawData.data.firstName,
          valid: rawData.data.valid
        };
      }

      // for all other error cases
      if (rawData?.code) {
        if (rawData?.code === 1013) {
          return {
            status: "FAIL",
            code: rawData?.code,
            error: rawData?.msg,
            message: "crediting.block-form.error.validation.failed"
          };
        }
        if (rawData?.code === 1005) {
          return {
            status: "FAIL",
            code: rawData?.code,
            error: rawData?.msg,
            message: "all.block-form.error.1005"
          };
        }

        if (i18n.exists("crediting.block-form.error." + rawData?.code)){
          return {
            status: "FAIL",
            code: rawData?.code,
            error: rawData?.msg,
            message: "crediting.block-form.error." + rawData?.code
          };
        }
        return {
          status: "FAIL",
          code: "1010",
          error: "System Error",
          message:   "all.block-form.error.1010"
        };
      }
      
    } catch (error: any) {
      setLoading(false);
      console.debug("ERROR: unexpected error occured ", error);
      return {
        status: "FAIL",
        code: "0000",
        error: "API down",
        message: "all.block-form.error.0000"
      };
    } finally {
      setLoading(false);
    }
  };

  return (
    <CreditingContext.Provider
      value={{
        loading,
        creditTransaction: creditTransaction
      }}
    >
      {props.children}
    </CreditingContext.Provider>
  );
};

export const useCrediting = () => {
  const context = React.useContext(CreditingContext);
  return context;
};
